import {
  amber,
  cyan,
  blue,
  purple,
  orange,
  teal,
  lime,
  brown,
} from "@material-ui/core/colors";

const shade = 200;
const colors = [
  amber[shade],
  cyan[shade],
  blue[shade],
  purple[shade],
  orange[shade],
  teal[shade],
  lime[shade],
  brown[shade],
];

export function getPollData(students, categoryName, optionNames) {
  let data = {
    Total: [0, 0, 0, 0, 0],
  };

  if (categoryName) {
    for (let optionName of optionNames) {
      if (optionName !== "Unknown") {
        data[optionName] = [0, 0, 0, 0, 0];
      }
    }
    data["Unknown"] = [0, 0, 0, 0, 0];
  }

  // Fulfill datasets with poll results
  if (Object.values(students).length) {
    for (let student of Object.values(students)) {
      // Get the student's answer and categories
      let studentVote = student.studentVote;
      let studentCategories = student.studentCategories;

      // Check whether the answer is valid or not
      studentVote = studentVote.replace(/[XG]/g, "");
      let studentVoteIndex = ["A", "B", "C", "D", "E"].indexOf(studentVote);
      if (studentVoteIndex === -1) {
        continue;
      }

      data["Total"][studentVoteIndex]++;

      if (categoryName) {
        // Get the student's option in category
        let optionName = studentCategories[categoryName];

        // Student's default option is 'Unknown'
        optionName = optionName === undefined ? "Unknown" : optionName;

        // Increment the count of the answer in the student's option by 1
        data[optionName][studentVoteIndex]++;
      }
    }
  }

  return data;
}

export function getGraphData(pollData, shownPoll, categoryName, optionsConfig) {
  let datasets = [
    {
      label: "No Data",
      data: [0, 0, 0, 0, 0],
    },
  ];

  let sum = 0;
  for (let subTotal in pollData["Total"]) {
    sum += pollData["Total"][subTotal];
  }

  if (Object.keys(pollData).length !== 0) {
    // If the poll is not empty, delete the default option
    datasets.splice(0, 1);

    let restCount = Array.from(pollData["Total"]);
    if (categoryName) {
      for (let optionConfig of optionsConfig) {
        if (optionConfig.checked) {
          datasets.push({
            label: optionConfig.optionName,
            data: pollData[optionConfig.optionName].map((count) =>
              Math.ceil((count / sum) * 100)
            ),
            backgroundColor: colors[optionConfig.index],
          });

          // Count the number of rest polls
          for (let index in restCount) {
            restCount[index] =
              restCount[index] - pollData[optionConfig.optionName][index];
          }
        }
      }
    } else {
      if (shownPoll.answer) {
        let idx = ["A", "B", "C", "D", "E"].indexOf(shownPoll.answer);
        let data = [0, 0, 0, 0, 0];
        data[idx] = (pollData["Total"][idx] / sum) * 100;

        datasets.push({
          label: "Correct",
          data: data,
          backgroundColor: "#00bf008f",
        });

        restCount[idx] = restCount[idx] - pollData["Total"][idx];
      }
    }

    datasets.push({
      label: "Rest",
      data: restCount.map((count) => Math.ceil((count / sum) * 100)),
      backgroundColor: "#808080af",
    });
  }

  return {
    labels: ["A", "B", "C", "D", "E"],
    datasets,
  };
}
